/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import moment from "moment";
import { useRouter } from "next/router";
import Image from "next/image";
import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";
import { ModalProvider } from "@/contexts/StockPageModal";

const isAllPrevIsNull = (data) =>
    data?.previousRevenue === null &&
    data?.previousOperatingProfit === null &&
    data?.previousOperatingProfitPercent === null &&
    data?.previousNim === null &&
    data?.previousNetProfit === null;

const checkIcon = (value) => {
    if (value > 0) {
        return "+";
    } else {
        return "";
    }
};

const intFixed = (value) => {
    if (typeof value === "number" && value !== 0) {
        return value.toFixed(2) + "%";
    } else {
        return "-";
    }
};

const byTen = (value) => {
    if (typeof value === "number" && value !== 0) {
        return (value / 10)?.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    } else {
        return "-";
    }
};

export default function ResultTable({ value, page }) {
    const router = useRouter();
    const modal = useContext(ModalProvider);
    const consolidatedExists =
        value.consolidatedExists && !isAllPrevIsNull(value.results?.filter((ele) => ele.type === "C")[0]);
    const standaloneExists =
        value.standaloneExists && !isAllPrevIsNull(value.results?.filter((ele) => ele.type === "S")[0]);

    const [btn, setBtn] = useState(consolidatedExists ? "C" : "S");
    const [data, setData] = useState({});

    useEffect(() => {
        setData(value.results?.filter((ele) => ele.type === btn)[0]);
    }, [btn]);

    const handleReadMore = () => {
        axiosInterceptorInstance.get(`/resources/stock-details/news/${value.newsId}`).then((res) => {
            let news = res?.data;
            modal.setTitle("More information");
            modal.setModalData(
                <div className="p-6 border h-[calc(100vh-200px)] overflow-y-auto">
                    <div className=" text-[14px] font-semibold leading-[24px] text-[#202020]">{news.heading}</div>
                    <div className=" mt-2 text-[12px] font-normal leading-[20px] text-[#414141]">
                        {news.date && moment(news.date).format("DD MMM 'YY | HH:MM A")}
                    </div>
                    <hr className="my-3" />
                    <div className="swiper-no-swiping w-full overflow-x-auto mb-4" id="backendNews">
                        <div dangerouslySetInnerHTML={{ __html: news.details }} />
                    </div>
                </div>
            );
            modal.setModal(true);
        });
        // router.push(`/stocks/news/${value.finCode}/${value.newsId}?backTo=results`);
    };

    const handleOnClick = () => {
        axiosInterceptorInstance.get(`resources/stock-details/prices-app?finCodes=${value.finCode}`).then((res) => {
            if (res.data.data?.list[0]?.expiryDateWithFinCodeList?.[0]) {
                router.push(`/stocks/${value.finCode}?openTab=2&backTo=results`);
            } else {
                router.push(`/stocks/${value.finCode}?openTab=1&backTo=results`);
            }
        });
    };

    return (
        <>
            <table className="table-fixed w-full font-Inter mb-3">
                <thead>
                    <tr className="bg-[#ECF6FE] font-semibold text-xs lg:text-sm text-black text-left">
                        <th className="pl-4 py-3 font-semibold">(In Rs Cr)</th>
                        <th className=" font-semibold">{moment(data?.previousQuarter, "YYYYMM").format("MMM 'YY")}</th>
                        <th className=" font-semibold">{moment(data?.quarter, "YYYYMM").format("MMM 'YY")}</th>
                        <th className=" font-semibold">YoY</th>
                    </tr>
                </thead>
                <tbody className=" text-xs lg:text-sm font-medium text-[#202020] border-separate border-spacing-y-2">
                    {data?.previousRevenue !== null && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">Revenue</td>
                            <td>{byTen(data?.previousRevenue)}</td>
                            <td>{byTen(data?.revenue)}</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.revenueChange)}
                                {intFixed(data?.revenueChange)}
                            </td>
                        </tr>
                    )}
                    {data?.previousOperatingProfit !== null && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">Op profit</td>
                            <td>{byTen(data?.previousOperatingProfit)}</td>
                            <td>{byTen(data?.operatingProfit)}</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.operatingProfitChange)}
                                {intFixed(data?.operatingProfitChange)}
                            </td>
                        </tr>
                    )}
                    {data?.previousOperatingProfitPercent !== null && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">Op profit%</td>
                            <td>{data?.previousOperatingProfitPercent?.toFixed(2)}%</td>
                            <td>{data?.operatingProfitPercent?.toFixed(2)}%</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.operatingProfitPercentChange)}
                                {intFixed(data?.operatingProfitPercentChange)}
                            </td>
                        </tr>
                    )}
                    {data?.previousNim !== null && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">NIM</td>
                            <td>{data?.previousNim?.toFixed(2)}%</td>
                            <td>{data?.nim?.toFixed(2)}%</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.nimChange)}
                                {intFixed(data?.nimChange)}
                            </td>
                        </tr>
                    )}
                    {byTen(data?.previousNetNPA) !== "-" && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">Net NPAs</td>
                            <td>{byTen(data?.previousNetNPA)}</td>
                            <td>{byTen(data?.netNPA)}</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.netNPAChange)}
                                {intFixed(data?.netNPAChange)}
                            </td>
                        </tr>
                    )}
                    {data?.previousNetProfit !== null && (
                        <tr className="border-b border-[#f5f5f5]">
                            <td className="pl-4 py-3 text-[#414141]">Net profit</td>
                            <td>{byTen(data?.previousNetProfit)}</td>
                            <td>{byTen(data?.netProfit)}</td>
                            <td className="flex justify-start items-center py-2">
                                {checkIcon(data?.netProfitChange)}
                                {intFixed(data?.netProfitChange)}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="mx-4 my-3 flex flex-row justify-start font-semibold gap-2">
                {standaloneExists && (
                    <button
                        className={`px-4 py-1 rounded text-xs ${
                            btn === "S" ? "bg-[#ECF6FE] text-black" : "border border-[#dfdfdf] text-[#909090]"
                        }`}
                        onClick={() => setBtn("S")}
                    >
                        Standalone
                    </button>
                )}
                {consolidatedExists && (
                    <button
                        className={`px-4 py-1 rounded text-xs ${
                            btn === "C" ? "bg-[#ECF6FE] text-black" : "border border-[#dfdfdf] text-[#909090]"
                        }`}
                        onClick={() => setBtn("C")}
                    >
                        Consolidated
                    </button>
                )}
                {page !== "stock_page" && (
                    <div className="flex ml-auto items-center gap-1" onClick={handleOnClick}>
                        <div className="py-1 rounded text-[10px] leading-[12px] text-[#00439D] whitespace-nowrap">
                            Past results
                        </div>
                        <svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.757042 8.9668L0 8.2531L3.48592 4.9668L0 1.68049L0.757042 0.966797L5 4.9668L0.757042 8.9668Z"
                                fill="#00439D"
                            />
                        </svg>
                    </div>
                )}
            </div>
            {value.newsId && (
                <div className={`px-4 py-3 flex flex-row justify-between items-center bg-[#ECF6FE]`}>
                    <div className="font-Inter  text-[10px] lg:text-xs text-[#202020] font-medium line-clamp-1">
                        {value?.newsTitle}
                    </div>
                    <div className="flex rounded px-2 py-1 border border-[#00439D] outline-none gap-1">
                        <div
                            className=" whitespace-nowrap text-xs text-[#00439D] font-semibold "
                            onClick={handleReadMore}
                        >
                            Read more
                        </div>
                        <svg
                            className="mt-[3px]"
                            width="6"
                            height="10"
                            viewBox="0 0 5 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.757042 8.9668L0 8.2531L3.48592 4.9668L0 1.68049L0.757042 0.966797L5 4.9668L0.757042 8.9668Z"
                                fill="#00439D"
                            />
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
}
